module.exports = __webpack_public_path__ + "img/network.ec48583d.svg";